import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader, Card, CardSection } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import loaderMentalWellness from "actions/mentalWellnessActions";
import messages from "components/messagesDescription";

const MentalWellness = ({ intl }) => {
  const dispatch = useDispatch();
  useEffect(() => dispatch(loaderMentalWellness()), []);
  const mentalWellnessData = useSelector(state => state.mentalWellness);
  if (mentalWellnessData.isFetching) return <Loader />;
  return (
    <div className="mental-wellness-container">
      <Card>
        <CardSection>
          <h5>{intl.formatMessage(messages.mentalWellness)}</h5>
          <div
            dangerouslySetInnerHTML={{ __html: mentalWellnessData.data.mentalWellnessWriteUp }}
          ></div>
        </CardSection>
      </Card>
    </div>
  );
};

MentalWellness.propTypes = {
  intl: intlShape.isRequired,
};
export default injectIntl(MentalWellness);



// WEBPACK FOOTER //
// ./components/wellness/MentalWellness.js